import React from "react";

const Achivement = () => {
  return (
    <div className="Achivement">
      <div className="container">
        <div className=" d-flex flex-row justify-content-between align-items-center">
          <div className="achievementCat">
            <h5>35+</h5>
            <p>National Awards</p>
          </div>

          <div className="achievementCat">
            <h5>45+</h5>
            <p>National Awards</p>
          </div>

          <div className="achievementCat">
            <h5>95+</h5>
            <p>National Awards</p>
          </div>

          <div className="achievementCat">
            <h5>135+</h5>
            <p>National Awards</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achivement;
